export const HEADERS = {
  X_LANGUAGE: 'x-language',
}
